module.exports = __webpack_public_path__ + "img/cry.b542d9f6.png";